import { Title, Space, Text } from "@mantine/core";

import OrderStatusStepper from "./orderStatusStepper";
import BoxOrderView from "./BoxOrderView";
import {
  getOrderStatusStep,
  convertDateToReadableFormat,
} from "../utils/order.utils";
import { isUserProvider, isUserStaff } from "../utils/user.utils";
import { STYLE, TOGGLE_FEATURE } from "../types/constants";
import { OrderStatus } from "../types/enums";
import {
  getDeliveryTrackingUrl,
  getLastTrackingNumber,
} from "../utils/shipping.utils";

const OrderViewStepperComponent = ({ order, user, id }) => {
  const orderDate = order.history.find(
    history => history.status === OrderStatus.CONFIRMED
  )?.createdAt;

  const lastTrackingNumber = getLastTrackingNumber(order?.shippings ?? []);
  const trackingUrl = getDeliveryTrackingUrl(
    order?.user?.userGroup?.deliveryCarrier,
    lastTrackingNumber
  );

  return (
    <BoxOrderView id={id} span={7} minHeight={28}>
      <Title
        order={5}
        style={{
          color: STYLE.primary,
        }}
      >
        Tracking
      </Title>
      <Space h="md" />
      <OrderStatusStepper
        id="order-status-stepper"
        orderStatus={getOrderStatusStep(order?.status)}
        order={order}
        labelsUnder={true}
        grow={true}
      />
      <Space h="md" />
      {order?.deliveryDate && (orderDate || order?.createdAt) && (
        <>
          <Text
            style={{
              fontWeight: "bold",
            }}
          >
            Ordered on:&nbsp;
            <span style={{ color: STYLE.primary }}>
              {convertDateToReadableFormat(orderDate ?? order.createdAt)}
            </span>
          </Text>
          <Text
            style={{
              fontWeight: "bold",
            }}
          >
            Last shipping date from provider:&nbsp;
            <span style={{ color: STYLE.primary }}>
              {convertDateToReadableFormat(order.lastShippingDate)}
            </span>
          </Text>
          {!isUserProvider(user) && (
            <Text
              style={{
                fontWeight: "bold",
              }}
            >
              Expected delivery on:&nbsp;
              <span style={{ color: STYLE.primary }}>
                {convertDateToReadableFormat(order.deliveryDate)}
              </span>
            </Text>
          )}
          <Text
            style={{
              fontWeight: "bold",
            }}
          >
            Status:&nbsp;
            <span style={{ color: STYLE.primary }}>
              {order.status === OrderStatus.PRODUCING_IN_TRANSIT &&
              isUserProvider(user)
                ? "SHIPPED TO FRANCE"
                : order.status}
              {order?.isArchived ? " - Archived" : ""}
            </span>
          </Text>
          {isUserStaff(user) && order?.provider?.name && (
            <Text
              style={{
                fontWeight: "bold",
              }}
            >
              Provider:&nbsp;
              <span style={{ color: STYLE.primary }}>
                {order?.provider?.name}
              </span>
            </Text>
          )}
          {isUserStaff(user) && lastTrackingNumber && (
            <>
              <Text
                style={{
                  fontWeight: "bold",
                }}
              >
                Tracking number:&nbsp;
                {trackingUrl ? (
                  <a
                    href={trackingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: STYLE.primary }}
                  >
                    {lastTrackingNumber}
                  </a>
                ) : (
                  <span style={{ color: STYLE.primary }}>
                    {lastTrackingNumber}
                  </span>
                )}
              </Text>
            </>
          )}
          {isUserStaff(user) && (
            <>
              <Text
                style={{
                  fontWeight: "bold",
                }}
              >
                Delivery Carrier:&nbsp;
                <span style={{ color: STYLE.primary }}>
                  {order?.user?.userGroup?.deliveryCarrier ?? "UNKNOWN"}
                </span>
              </Text>
              <Text
                style={{
                  fontWeight: "bold",
                }}
              >
                Pickup Carrier:&nbsp;
                <span style={{ color: STYLE.primary }}>
                  {order?.user?.userGroup?.pickupCarrier ?? "UNKNOWN"}
                </span>
              </Text>
              {isUserStaff(user) && order?.shippedBackToProviderDate && (
                <Text
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  Shipped back to China on:&nbsp;
                  <span style={{ color: STYLE.primary }}>
                    {convertDateToReadableFormat(
                      order.shippedBackToProviderDate
                    )}
                  </span>
                </Text>
              )}
            </>
          )}
        </>
      )}
    </BoxOrderView>
  );
};

export default OrderViewStepperComponent;
